import { useContext } from 'react';
import { ResultContext } from '../context';

export function useResultContext() {
	return useContext(ResultContext);
}
